import styled from 'styled-components';

import {FormError} from './FormError';

export const FormHelper = styled(FormError)`
  color: ${({theme}) => theme.colors.palettes.neutral[300][100]};
`;
